// extracted by mini-css-extract-plugin
export default {"InputContainer":"_InputContainer--Oyc8Z","Error":"_Error--zNKwl","Chars":"_Chars--NzKzQ"};